export class InviteUser {
    constructor(
        public id: string = null,
        public email: string = null) {
    }
}
